import { IconProps } from './type';

export const ICService: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="24" y="22" width="80" height="84" rx="16" fill="#4f4b5c" />
            <circle cx="64" cy="58" r="22" fill="#F4C95D" />
            <circle cx="64" cy="58" r="8" fill="#4f4b5c" />
            <path
                d="M48 88L80 56"
                stroke="#F4C95D"
                strokeWidth={8}
                strokeLinecap="round"
            />
            <path
                d="M80 44C75 45 72 50 73 55L63 65L71 73L81 63C86 64 91 61 92 56L85 58L78 51L80 44Z"
                fill="#F4C95D"
            />
        </svg>
    );
};
